// extracted by mini-css-extract-plugin
module.exports = {"component":"inspirational-search-flow-step-indicator_component__YlbBJ"};